// grant-giles-2026 theme entry.
// Rollup bundles this into assets/built/index.js and (via the CSS import)
// assets/built/index.css.

import "../css/index.css";

import dateline from "./modules/dateline.js";
import weather from "./modules/weather.js";
import reveal from "./modules/reveal.js";
import navToggle from "./modules/navToggle.js";
import hello from "./modules/hello.js";
import practice from "./modules/practice.js";
import toc from "./modules/toc.js";
import contentsSheet from "./modules/contentsSheet.js";
import marginNotes from "./modules/marginNotes.js";
import sectionNav from "./modules/sectionNav.js";
import writingsList from "./modules/writingsList.js";
import podcastList from "./modules/podcastList.js";
import episodePlayer from "./modules/episodePlayer.js";
import episodeImageMaker from "./modules/episodeImageMaker.js";
import checkup from "./modules/checkup.js";
import calendar from "./modules/calendar.js";
import reelsReview from "./modules/reelsReview.js";
import speedReps from "./modules/speedReps.js";
import coachForm from "./modules/coachForm.js";
import cal from "./modules/cal.js";
import credits from "./modules/credits.js";
import years from "./modules/years.js";
import offCourse from "./modules/offCourse.js";
import memberInitials from "./modules/memberInitials.js";
import season from "./modules/season.js";
import boo from "./modules/boo.js";
import place from "./modules/place.js";

function init() {
    place();
    dateline();
    weather();
    reveal();
    navToggle();
    hello();
    practice();
    toc();
    contentsSheet();
    marginNotes();
    sectionNav();
    writingsList();
    podcastList();
    episodePlayer();
    episodeImageMaker();
    checkup();
    calendar();
    reelsReview();
    speedReps();
    coachForm();
    cal();
    credits();
    years();
    offCourse();
    memberInitials();
    season();
    boo();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
